import {
    getPrice,
    listPrices
} from './queries';
import {
    createPrice,
    deletePrice,
    updatePrice,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {
    CreatePrice,
    DeletePrice,
    GetPrice,
    ListPrices,
    Price,
    UpdatePrice
} from "../types.ts";
import { billingApiClient } from "../../billing-api-integration";
import {ListRecordsQuery} from "../../../types";


const client = billingApiClient;

const normalizeFilter = (filter: { [key: string]: string }) =>
    Object.keys(filter).reduce((acc: { [key: string]: string }, key) => {
        if (filter[key] !== '' && filter[key] !== undefined) {
            acc[key] = filter[key];
        }
        return acc;
    }, {});

export const fetchRecords = async (productId: string, query: ListRecordsQuery) => {
    const { filter, ...rest } = query;
    const transformedFilter = filter ? normalizeFilter(filter as { [key: string]: string }) : {};

    const response = await client.graphql<GraphQLQuery<ListPrices>>({
                                                                        query: listPrices,
                                                                        variables: {
                                                                            productId: productId,
                                                                            ...rest,
                                                                            ...(Object.keys(transformedFilter).length ? { filter: transformedFilter } : {})
                                                                        },
                                                                    });

    return {
        items: response.data?.listPrices.items || [],
        nextToken: response.data?.listPrices.nextToken
    }
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetPrice>>({
                                                                      query: getPrice,
                                                                      variables: {id: id},
                                                                  });
    return response.data?.getPrice;
};

export const add = async (payload: object) => {
    const response = await client.graphql<GraphQLQuery<CreatePrice>>({
                                                                         query: createPrice,
                                                                         variables: {input: payload},
                                                                     });
    console.debug('in the service response', response);
    return response.data?.createPrice;
};

export const update = async (id: string, record: Price) => {

    console.debug('IN UPDATE', id, record);

    // Only send fields allowed in UpdatePriceInput
    const updateInput = {
        id: record.id,
        productId: record.productId,
        recurringOption: record.recurringOption,
        priceStatus: record.priceStatus,
        pricingModel: record.pricingModel,
        amount: record.amount,
        ratePlanId: record.ratePlanId,
        description: record.description,
        billingPeriod: record.billingPeriod
    };

    const response = await client.graphql<GraphQLQuery<UpdatePrice>>({
                                                                         query: (updatePrice),
                                                                         variables: {input: updateInput},
                                                                     });
    return response.data?.updatePrice;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeletePrice>>({
                                                                         query: (deletePrice),
                                                                         variables: {input: {id: id}},
                                                                     });
    return response.data?.deletePrice;
};
